/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Error } from '../models/Error'
import type { NoteEntitySource } from '../models/NoteEntitySource'
import type { RequestCreateNote } from '../models/RequestCreateNote'
import type { RequestUpdateNote } from '../models/RequestUpdateNote'
import type { ResponseGetNote } from '../models/ResponseGetNote'

import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'

export class NotesService {
  /**
   * Tworzy notatkę
   * @returns Error unexpected error
   * @returns any dane zapisane
   * @throws ApiError
   */
  public static createNewNote({
    requestBody,
  }: {
    /**
     * dodanie nowej notatki
     */
    requestBody?: RequestCreateNote
  }): CancelablePromise<Error | any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/note',
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Edytuje notatkę
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static editNote({
    entityId,
    entitySource,
    requestBody,
  }: {
    entityId: number
    entitySource: NoteEntitySource
    /**
     * dane notatki
     */
    requestBody?: RequestUpdateNote
  }): CancelablePromise<Error> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/note/{entityId}/{entitySource}',
      path: {
        entityId: entityId,
        entitySource: entitySource,
      },
      body: requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * Usuwa notatkę
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static deleteNote({
    entityId,
    entitySource,
  }: {
    entityId: number
    entitySource: NoteEntitySource
  }): CancelablePromise<Error> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/note/{entityId}/{entitySource}',
      path: {
        entityId: entityId,
        entitySource: entitySource,
      },
    })
  }

  /**
   * Zwraca notatki dla EntityId
   * @returns ResponseGetNote notatki
   * @returns Error unexpected error
   * @throws ApiError
   */
  public static getNotes({
    entityId,
    entitySources,
  }: {
    entityId: number
    entitySources: Array<NoteEntitySource>
  }): CancelablePromise<Array<ResponseGetNote> | Error> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/notes/{entityId}',
      path: {
        entityId: entityId,
      },
      query: {
        entitySources: entitySources,
      },
    })
  }
}
